import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SeasonalRentalService } from '@app/listing/services/seasonal-rental.service';
import { SeasonalRentalViewModel } from '@app/models';
import Listing from '@app/models/listing';
import { NotificationService, UserService } from '@app/services';
import { SpinnerComponent } from '../../../common-components/spinner/spinner.component';
import { LinkToNewAdminListingComponent } from '../link-to-new-admin-listing/link-to-new-admin-listing.component';
import { NgIf, NgFor, CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: "seasonal-lease-grid-view",
    templateUrl: "./seasonal-lease-grid-view.component.html",
    styleUrls: ["./seasonal-lease-grid-view.component.less"],
    imports: [NgIf, NgFor, LinkToNewAdminListingComponent, SpinnerComponent, CurrencyPipe, DatePipe]
})
export class SeasonalLeaseGridViewComponent implements OnInit {
  private readonly _componentName = 'SeasonalLeaseGridViewComponent';
  private _seasonalLeases: SeasonalRentalViewModel[];

  public loading = false;

  @Input() listing: Listing;

  private _allowDelete: boolean;
  private _canDelete: boolean;
  private _allowBook = false;
  private _allowEdit = true;
  private _showEditButton: boolean;
  private _showDeleteButton: boolean;
  private _showBookRentalButton: boolean;

  /**
   * Backing field for the showListingDescription property
   */
  private _showListingDescription = false;

  /**
   * Deleted event for when the seasonal rental is deleted
   */
  @Output() deleted = new EventEmitter<number>();

  /**
   * Start Editing event for when the Edit button is pressed.
   */
  @Output() startEdit = new EventEmitter<SeasonalRentalViewModel>();

  constructor(
    readonly notify: NotificationService,
    readonly userService: UserService,
    readonly seasonalRentalService: SeasonalRentalService,
    private router: Router
  ) {}

  public get seasonalLeases(): SeasonalRentalViewModel[] {
    return this._seasonalLeases;
  }

  @Input()
  public set seasonalLease(v: SeasonalRentalViewModel) {
    if (!this.seasonalLeases) {
      this.seasonalLeases = [];
    }
    this.seasonalLeases.push(v);
  }

  @Input()
  public set seasonalLeases(v: SeasonalRentalViewModel[]) {
    this._seasonalLeases = v;
  }

  @Input()
  public get allowBook(): boolean {
    return this._allowBook;
  }
  public set allowBook(v: boolean) {
    this._allowBook = v;
  }

  /**
   * Property flag if the user is an admin
   */
  public get isAdmin(): boolean {
    return this.userService.isAdmin;
  }

  public get allowDelete(): boolean {
    return this._allowDelete;
  }
  public set allowDelete(v: boolean) {
    this._allowDelete = v;
  }

  public get canDelete(): boolean {
    return this._canDelete;
  }
  public set canDelete(v: boolean) {
    this._canDelete = v;
  }

  public get allowEdit(): boolean {
    return this._allowEdit;
  }
  public set allowEdit(v: boolean) {
    this._allowEdit = v;
  }

  public showReservationMessage(seasonalLease: SeasonalRentalViewModel) {
    if (this.isAdmin && seasonalLease && seasonalLease.reservationId && seasonalLease.reservationId > 0) {
      return true;
    }

    return false;
  }

  public get showEditButton(): boolean {
    return this._showEditButton;
  }

  @Input()
  public set showEditButton(v: boolean) {
    this._showEditButton = v;
  }

  public get showDeleteButton(): boolean {
    return this._showDeleteButton;
  }

  @Input()
  public set showDeleteButton(v: boolean) {
    this._showDeleteButton = v;
  }

  public get showBookRentalButton(): boolean {
    return this._showBookRentalButton;
  }

  @Input()
  public set showBookRentalButton(v: boolean) {
    this._showBookRentalButton = v;
  }

  /**
   * Property getter for controlling the visibility of the listing description
   */
  public get showListingDescription(): boolean {
    return this._showListingDescription;
  }

  /**
   * Property setter for controlling the visibility of the listing description
   */
  @Input()
  public set showListingDescription(v: boolean) {
    this._showListingDescription = v;
  }

  ngOnInit() {}

  public onReservationClick(item: SeasonalRentalViewModel) {
    console.log(`${this._componentName}.onReservationClick() item=`, item);

    if (item.reservationId) {
      this.router.navigate(['/admin/reservation', item.reservationId]);
    }
  }

  onBookRentalButtonClick() {
    console.log('SeasonalRentalCardComponent.onBookRentalButtonClick');

    this.notify.notImplemented(null);
  }
}
